<template lang="">
  <div>

    <!-- search -->
    <div class="search">
      <el-form :model="searchForm" size="small" label-width="80px">
        <el-col :span="6" class="formWidth">
          <el-form-item label="奖项名称">
            <el-input v-model="searchForm.awardname" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6" class="formWidth">
          <el-form-item label="所属活动">          
            <el-select v-model="searchForm.competitionid" placeholder="请选择" clearable @change="getPrizeType(searchForm.competitionid,2)">
              <el-option v-for="item in activityList" :label="item.abbrname" :key="item.competitionid" :value="item.competitionid"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7" class="formWidth">
          <el-form-item label="所属分类">
            <el-cascader v-model="searchForm.prizeTypeSelect" :options="prizeTypeList2" @change="changeTypeid(searchForm.prizeTypeSelect)" :props="defaultProps" clearable></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="5" class="formWidth" style="float: right;text-align: right;;">
          <el-form-item label="" label-width="0px">
            <el-button type="success" size="small" @click="getlist()"><i class="fa fa-search"></i> 查 询</el-button>
            <el-button type="primary" size="small" @click="prizeAdd()"><i class="fa fa-plus"></i> 创建奖项</el-button>
          </el-form-item>          
        </el-col>
        
        <el-col :span="7" class="formWidth">
          <el-form-item label="状态" >          
            <el-radio-group v-model="searchForm.awardstatus">
              <el-radio-button label="">全部</el-radio-button>
              <el-radio-button label="1">启用</el-radio-button>
              <el-radio-button label="2">未启用</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        
        <el-col :span="3" class="formWidth" style="float: right;text-align: right;;">
          <el-form-item label="" label-width="0px">
            <el-dropdown >
              <el-button type="primary" size="small">
                批操作<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="setMulScore()">评分设置</el-dropdown-item>
                <!-- <el-dropdown-item>删除</el-dropdown-item> -->
              </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>
        </el-col>
        <div class="clear"></div>
      
      </el-form>
    </div>

    <!-- list -->
    <div class="list" v-loading="loading">
      <el-table class="highlight" border :data="list" ref="multipleTable" stripe style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="30" align="center"></el-table-column>
        <el-table-column prop="awardname" label="奖项名称"></el-table-column>
        <el-table-column prop="abbrname" label="所属活动"></el-table-column>
        <el-table-column prop="typename" label="奖项分类"></el-table-column>
        <el-table-column prop="memo" label="备注"></el-table-column>
        <el-table-column prop="" align="center" width="100" label="状态">
          <template slot-scope="scope">
            {{scope.row.awardstatus|filterStatus}}
          </template>
        </el-table-column>
        <el-table-column prop="" align="center" label="操作">
          <template slot-scope="scope">
            <span><a href="javascript:void(0)" @click="prizeEdit(scope.row)">编辑</a></span>
            <span> | <a href="javascript:void(0)" @click="setScore(scope.row)">评分设置</a></span>
            <span> | <a href="javascript:void(0)" @click="prizeDelete(scope.row.awardid,scope.row.awardname)">删除</a></span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination background layout="total, prev, pager, next, jumper" :total="total" :current-page="searchForm.page" @current-change="current_change" :page-size="searchForm.length"></el-pagination>
    </div>

    <!-- add/edit -->
    <el-dialog :title="(newPrize)?'奖项创建':'编辑奖项'" :visible.sync="prizeInfoDialog" :width="dialogWidth" :close-on-click-modal="false">
      <el-form :model="prizeInfo" ref="prizeInfo" size="small" label-width="100px">
        <el-form-item label="奖项名称" v-if="!newPrize" prop="awardname" :rules="{ required: true, message: '请填写', trigger: 'blur' }">
          <el-input v-model="prizeInfo.awardname" ></el-input>
        </el-form-item>
        <el-form-item label="所属活动" prop="competitionid" :rules="{ required: true, message: '请填写', trigger: 'blur' }">
          <el-select v-model="prizeInfo.competitionid" placeholder="请选择" @change="getPrizeType(prizeInfo.competitionid,1)">
            <el-option v-for="item in activityList" :label="item.abbrname" :value="item.competitionid" :key="item.competitionid"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="prizeTypeList.length>0" label="所属分类" prop="typeid" :rules="{ required: true, message: '请填写', trigger: 'blur' }">          
          <el-tree
            :data="prizeTypeList"
            show-checkbox
            node-key="typeid"
            check-strictly
            ref="treeForm"
            :default-checked-keys="prizeTypeArr"
            :default-expanded-keys="prizeTypeArr"
            auto-expand-parent
            @check-change="handleNodeClick"
            :props="defaultProps">
          </el-tree>
        </el-form-item>
        <el-form-item label="奖项名称" v-if="newPrize" prop="awardname" :rules="{ required: true, message: '请填写', trigger: 'blur' }">
          <el-input v-model="prizeInfo.awardname" :rows="5" type="textarea" placeholder="批量录入奖项名称，奖项名称之间用“、”区隔，如“奖项名称1、奖项名称2、奖项名称3”" ></el-input>
        </el-form-item>
        <el-form-item label="奖项备注" v-if="!newPrize">
          <el-input v-model="prizeInfo.memo" ></el-input>
        </el-form-item>
        <el-form-item label="奖项状态" prop="awardstatus" :rules="{ required: true, message: '请填写', trigger: 'blur' }">
          <el-radio-group v-model="prizeInfo.awardstatus">
            <el-radio-button label="1">启用</el-radio-button>
            <el-radio-button label="2">不启用</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="success" @click="prizeInfoDialog=false"><i class="fa fa-times"></i> 取 消</el-button>
        <el-button size="small" type="primary" @click="savePrize('prizeInfo')"><i class="fa fa-check"></i> 保 存</el-button>
      </div>
    </el-dialog>

    <!-- 评分设置 -->
    <el-dialog title="评分设置" :visible.sync="setScoreDialog" :width="dialogWidth" :close-on-click-modal="false">
      <el-form :model="scoreInfo" ref="scoreInfo" size="small" label-width="100px">
        <el-form-item label="奖项总分" style="width:50%">
          <el-input v-model="totalScore" disabled></el-input>
        </el-form-item>
        <p v-for="item,index in scoreInfo.items">
          <el-form-item :label="'评分项目'+(index+1)" style="width:50%" :prop="'items.' + index + '.item_name'" :rules="{ required: true, message: '请填写', trigger: 'blur' }">
            <el-input v-model="item.item_name" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item :label="'项目权重'+(index+1)" style="width:44%" :prop="'items.' + index + '.score'" :rules="{ required: true, message: '请填写', trigger: 'blur' }">
            <el-input v-model="item.score" type="number" placeholder="请输入内容"></el-input>
          </el-form-item>
          <span v-if="index==0" class="score_btn text-primary" @click="addScoreItem()" title="添加评分项目"><i class="fa fa-plus"></i></span>
          <span v-if="index!=0" class="score_btn text-primary" @click="removeScoreItem(item)" title="移除评分项目"><i class="fa fa-minus"></i></span>
        </p>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="success" @click="setScoreDialog=false"><i class="fa fa-times"></i> 取 消</el-button>
        <el-button size="small" type="primary" @click="saveSetScore('scoreInfo')"><i class="fa fa-check"></i> 保 存</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
  import * as API from '@/api/main'
export default {
  data() {
    return {
      loading:false,
      total:0,
      searchForm:{
        page:1,
        length:10,
        awardstatus:"",
      },
      list:[],
      prizeInfo:{
        awardname:"",
        competitionid:"",
        memo:"",
        awardstatus:"",
        awardid:"",
      },
      prizeInfoDialog:false,//添加、编辑活动面板开关
      newPrize:true,
      statusList:[],//状态list
      typeList:[],//类别list
      activityList:[],
      defaultProps: {
        children: 'children',
        label: 'typename',
        value:'typeid',
      },
      prizeTypeList:[],
      prizeTypeList2:[],
      dialogWidth:"600px",
      prizeTypeArr:[],
      prizeTypeSelect:[],
      setScoreDialog:false,//评分设置面板
      scoreInfo:{        
        items:[
          // {item_name:"",score:0},
        ],        
      },//评分信息
      totalScore:0,
      multipleSelection: [],//已选行
    };
  },
  filters:{
    filterStatus(value){
      let str = "";
      switch (value) {
        case 1:
          str = "启用";
          break;
        case 2:
          str = "未启用";
          break;
      }
      return str;
    }
  },
  watch:{

    "searchForm.awardstatus":{
      handler: function() {
        this.search()
      },      
    },

    'scoreInfo.items':{
      handler:function(newValue){
        this.totalScore=0;
        for(var i=0;i<newValue.length;i++){
          this.totalScore+=Number(newValue[i].score);
        }
      },
      deep:true,
    },

  },
  methods: {

    //获取列表
    getlist(){
      this.loading=true;
      API.GetPrizeList(this.searchForm).then(res=>{
        this.list=res.data.data;
        this.loading=false;
        this.total=res.data.total;
      })
    },

    //获取活动列表
    getActivityList(){
      this.loading=true;
      let postdata={
        page:1,
        length:100,
        status:"",
      }
      API.GetActivityList(postdata).then(res=>{
        this.activityList=res.data.data;
      })
    },

    //分页
    current_change(currentPage){
      // console.log(currentPage)
      this.searchForm.page = currentPage;
      this.getlist();
    },

    //查询
    search(){
      this.current_change(1);
    },

    //添加奖项
    prizeAdd(){
      this.newPrize=true;
      this.prizeInfoDialog=true;
      this.prizeTypeArr=[];
      this.prizeTypeList=[];
      this.prizeInfo={
        awardname:"",
        competitionid:"",
        memo:"",
        awardstatus:"",
        awardid:"",
        typeid:"",
      }
    },

    //编辑活动
    prizeEdit(prizeInfo){
      this.newPrize=false;
      this.prizeInfoDialog=true;
      console.log(prizeInfo)
      this.prizeInfo={
        awardname:prizeInfo.awardname,
        competitionid:prizeInfo.competitionid,
        memo:prizeInfo.memo,
        awardstatus:prizeInfo.awardstatus,
        awardid:prizeInfo.awardid,
        typeid:prizeInfo.typeid,
      }
      this.prizeTypeArr=[];
      this.prizeTypeArr.push(prizeInfo.typeid)
      this.getPrizeType(prizeInfo.competitionid,1)
    },

    //重置校验
    resetForm(formName) {
        this.$refs[formName].resetFields();
    },

    //提交保存
    savePrize(formName){
      console.log(this.prizeInfo)
      this.$refs[formName].validate((valid) => {
          if (valid) {
            if(this.newPrize){
              API.PrizeAdd(this.prizeInfo).then(res=>{
                this.$message({
                  message: res.info,
                  type: 'success'
                });
                this.prizeInfoDialog=false;              
                this.resetForm(formName);
                this.search();
              })
            }else{
              API.PrizeEdit(this.prizeInfo).then(res=>{
                this.$message({
                  message: res.info,
                  type: 'success'
                });
                this.prizeInfoDialog=false;              
                this.resetForm(formName);
                this.getlist();
              })
            }            
          } else {
            return false;
          }
        });
    },

    //删除
    prizeDelete(id,name){
      this.$confirm('确定删除“'+name+'”奖项?', '提示', {
          confirmButtonText: '确 定',
          cancelButtonText: '取 消',
          type: 'warning'
        }).then(() => {
          API.PrizeDelete({awardid:id}).then(res=>{        
            this.$message({
              message: '奖项已删除',
              type: 'success',
            })
            this.getlist();
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },

    diffrentScreen(){
      if(document.body.clientWidth<1200){
        this.dialogWidth="100vw";
      }
    },

    //获取分类列表
    getPrizeType(id,n){
      if(id){
        API.GetAwardType({competitionid:id,is_data:0}).then(res=>{
          if(n==1){
            this.prizeTypeList=_.cloneDeep(res.list);
            for(var i=0;i<this.prizeTypeList.length;i++){    
              if(this.prizeTypeList[i].children.length>0){
                this.prizeTypeList[i].disabled=true;
              }
            }
          }else if(n==2){
            this.prizeTypeList2=_.cloneDeep(res.list);
            for(var i=0;i<this.prizeTypeList2.length;i++){              
              this.prizeTypeList2[i].disabled=false;
              if(this.prizeTypeList2[i].children.length>0){
                for(var j=0;j<this.prizeTypeList2[i].children.length;j++){
                  this.prizeTypeList2[i].children[j].disabled=false;
                  delete this.prizeTypeList2[i].children[j].children
                }
              }else{
                delete this.prizeTypeList2[i].children;
              }
            }
          }        
          this.$forceUpdate();
          console.log(this.prizeTypeList2)
        })
      }else{
        if(n==1){
            this.prizeTypeList=[];
          }else if(n==2){
            this.prizeTypeList2=[];
            this.searchForm.prizeTypeSelect=[];
            this.searchForm.typeid="";
          }
      }      
    },

    //单选树
    handleNodeClick(data, checked, node) {
        if(checked === true) {
            this.checkedId = data.typeid;
            this.$refs.treeForm.setCheckedKeys([data.typeid]);
            this.prizeInfo.typeid=data.typeid;
            console.log(this.prizeInfo.typeid);
            this.$forceUpdate();
        } else {
            if (this.checkedId == data.typeid) {
                this.$refs.treeForm.setCheckedKeys([data.typeid]);
            }
        }
    },

    change(e){
      this.$forceUpdate();
    },

    //search获取typeID
    changeTypeid(arr){
      if(arr.length>0){
        this.searchForm.typeid=arr[arr.length-1];
      }
      console.log(this.searchForm.typeid)
    },

    //评分设置
    setScore(item){
      this.$refs.multipleTable.clearSelection();
      this.scoreInfo.awardid=[];
      this.scoreInfo.awardid.push(item.awardid);
      this.scoreInfo.items=_.cloneDeep(item.items);
      if(this.scoreInfo.items.length==0){
        this.scoreInfo.items.push({item_name:"",score:0});
      }
      this.setScoreDialog=true;
    },

    //批量评分设置
    setMulScore(){
      this.scoreInfo.awardid=_.cloneDeep(this.multipleSelection);
      if(this.scoreInfo.awardid.length==0){
        this.$message({
          message: "请先选择奖项",
          type: 'warning'
        });
      }else{        
        this.scoreInfo.items=[];
        this.scoreInfo.items.push({item_name:"",score:0});
        console.log(this.scoreInfo)
        this.setScoreDialog=true;
      }
      
    },

    //增加评分项目
    addScoreItem(){
      this.scoreInfo.items.push({item_name:"",score:0});
    },

    //移除评分项目
    removeScoreItem(item){
      var index = this.scoreInfo.items.indexOf(item)
      if (index !== -1) {
        this.scoreInfo.items.splice(index, 1)
      }
      this.$forceUpdate();
    },

    //保存评分设置
    saveSetScore(formName){
      console.log(this.scoreInfo)
      this.$refs[formName].validate((valid) => {
        if (valid) {
            API.SaveSetScore(this.scoreInfo).then(res=>{
              this.$message({
                message: res.info,
                type: 'success'
              });
              this.setScoreDialog=false;              
              this.resetForm(formName);
              this.getlist();
            })
        } else {
          return false;
        }
      });
    },

    //获取多选行
    handleSelectionChange(val) {
      this.multipleSelection=[]
      for(let i=0;i<val.length;i++){
        this.multipleSelection.push(val[i].awardid);
      }
      // console.log(this.multipleSelection)
    }

  },
  created() {
    
    this.getlist();
    this.getActivityList();
    this.diffrentScreen();

  },
  
}
</script>
<style scoped>
  .search{padding-bottom:20px;}
  .score_btn{width:6%;display:inline-block;text-align: right;cursor: pointer;;}
</style>